import {
    cardLinkNeutralDarkest,
    cardLinkNeutralMedium,
} from '@/src/card-linking/components/colors'

interface ICardPreview {
    cardId: string
    cardNetwork: string
    cardLastFour: string
    style?: object
    labelStyle?: object
}

export function CardPreview({
    cardId,
    cardNetwork,
    cardLastFour,
    style = {},
    labelStyle = {},
}: ICardPreview) {
    let networkImage: string = ''

    switch (cardNetwork.toLowerCase()) {
        case 'visa':
            networkImage = '/images/card-linking/cc-visa.svg'
            break
        case 'amex':
            networkImage = '/images/card-linking/cc-amex.svg'
            break
        case 'mastercard': {
            networkImage = '/images/card-linking/cc-mastercard.svg'
            break
        }
        default:
            break
    }

    return (
        <div style={style}>
            <label
                htmlFor={cardId}
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    columnGap: '2rem',
                    cursor: 'pointer',
                    ...labelStyle,
                }}
            >
                <svg
                    width="114"
                    height="77"
                    style={{
                        borderRadius: '10px',
                        width: '114px',
                        height: '77px',
                        filter: 'brightness(0) saturate(100%) invert(84%) sepia(3%) saturate(542%) hue-rotate(177deg) brightness(91%) contrast(87%)',
                    }}
                >
                    <image
                        xlinkHref={networkImage}
                        style={{
                            width: '114px',
                            height: '77px',
                        }}
                    />
                </svg>
                <div>
                    <h4
                        style={{
                            marginBottom: '1rem',
                            color: cardLinkNeutralDarkest,
                        }}
                    >
                        {cardNetwork ? cardNetwork.toUpperCase() : 'unknown'}
                    </h4>
                    <h4
                        style={{
                            marginTop: '0',
                            color: cardLinkNeutralMedium,
                        }}
                        className={'fs-mask fs-exclude'}
                    >
                        ************
                        {cardLastFour}
                    </h4>
                </div>
            </label>
        </div>
    )
}
